/**
 * ActivityStream — dense, recency-sorted list of trials from the host-lens
 * snapshot. The parent passes an already-sorted TrialLite[] (newest-activity
 * first); this component renders, handles the empty state, and delegates per-row
 * presentation and click to TrialRow.
 *
 * Purely presentational — no fetch, no polling, no global reads.
 */

import { TrialRow } from './TrialRow'
import type { TrialLite } from './board-types'
import { runColor } from './run-color'

export interface ActivityStreamProps {
  /** Already-sorted newest-activity-first list from the host-lens snapshot. */
  trials: TrialLite[]
  /** Called with the trialId when a row is clicked — parent wires to the drawer. */
  onSelect: (trialId: string) => void
}

export function ActivityStream({ trials, onSelect }: ActivityStreamProps): React.JSX.Element {
  if (trials.length === 0) {
    return (
      <div className="activity-stream-empty">
        <p className="activity-stream-empty-msg">No active trials — start a run to see the pipeline.</p>
      </div>
    )
  }

  return (
    <ul className="activity-stream" aria-label="Trial activity stream">
      {trials.map((trial) => (
        <TrialRow key={trial.id} trial={trial} color={runColor(trial.runId)} onClick={() => onSelect(trial.id)} />
      ))}
    </ul>
  )
}
